import { render } from "./COPOPSO.vue?vue&type=template&id=7bfa3d54&scoped=true"
import script from "./COPOPSO.vue?vue&type=script&lang=js"
export * from "./COPOPSO.vue?vue&type=script&lang=js"

import "./COPOPSO.vue?vue&type=style&index=0&id=7bfa3d54&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bfa3d54"]])

export default __exports__